import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Grid,
  Box,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

import { fetchInsurancePlansSuccess } from '../../redux/InsurancePlans';

import api from '../../api';
import { setErrorMessage } from '../../redux/errors';
import { mapErrorMessage } from '../../utils';

import WizardLayout from '../../components/WizardLayout';
import WizardNavigation from '../../components/WizardNavigation';
import PlanCard from '../../components/PlanCard';
import PlanCardCar from '../../components/PlanCardCar';
import CardsCarousel from '../../components/CardsCarousel';
import Modal from '../../components/Modal';
import ModelForm from '../../components/ModelForm';
import CompanyInfo from '../../components/CompanyInfo';
import { setTaxes } from '../../redux/taxesData';
import { setActivityName } from '../../redux/activityNameData';

import { setCarInsurance } from '../../redux/carInsurance';

import {
  fetchInsurancePlans,
  setSelectedInsurancePlan,
} from '../../redux/InsurancePlans';
import useWizardSteps from '../../hooks/useWizardSteps';
import LifeDeclaration from '../../components/LifeDeclaration';
import LoadingCars from '../../components/LoadingCars';

const nextSteps = {
  HOGAR: '/domicilio',
  'PERTENENCIAS PROTEGIDAS': '/beneficiarios',
  'MOVILIDAD': '/beneficiarios',
  'VIDA INDIVIDUAL': '/beneficiarios',
  'ACCIDENTES PERSONALES': '/beneficiarios',
  'ROBO EN CAJERO AUTOMATICO': '/beneficiarios',
  MASCOTA: '/mascota/detalles',
  AUTOMOTOR: '/automotor/datosauto',
};

const useStyles = makeStyles((theme) => ({
  navigationContainer: {
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
  },
}));

export default function SelectPlan() {
  useEffect(() => {
    if (insuranceName === 'AUTOMOTOR') {
      async function fetchDataAutosValue() {
        try {
          const { data } = await api.post(
            `/seguros/vehiculo/precio/ch/PDS`,
            {
              generic: {
                infoAutoCode: userCarInsurance.carVersion,
                listGroups: '',
                listModels: '',
                productionYear: userCarInsurance.carYear,
              },
              vehicleBrand: {
                vehicleBrandId: userCarInsurance.carBrand,
              },
              vehicleGroup: {
                vehicleGroupId: userCarInsurance.carModel,
              },
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          dispatch(
            userCarInsurance.isNew === 'true'
              ? setCarInsurance({
                  carTotalAmountInsured:
                    data.vehicleBrand[0].vehicleGroups[0].vehicleModels[0]
                      .vehiclePrices[1].price,
                })
              : setCarInsurance({
                  carTotalAmountInsured:
                    data.vehicleBrand[0].vehicleGroups[0].vehicleModels[0]
                      .vehiclePrices[0].price,
                })
          );
        } catch (error) {
          dispatch(setErrorMessage(mapErrorMessage('systemError')));
          history.push(`/error`);
        }
      }
      fetchDataAutosValue();
    }
  }, []);

  const { user } = useSelector(({ user }) => ({
    user,
  }));

  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    if (insuranceName === 'AUTOMOTOR') {
      async function fetchDataPlanAutos() {
        try {
          const { data } = await api.post(
            `/seguros/planes/vehiculo/ch/PDS`,
            {
              generic: {
                code: userCarInsurance.carVersion,
                gnc: userCarInsurance.carGNC,
                gncValue:
                  userCarInsurance.carGNC === 'true'
                    ? userCarInsurance.carPriceGNC
                    : 0,
                isNew: userCarInsurance.isNew,
                productionYear: userCarInsurance.carYear,
                use: '01',
              },
              customer: {
                basicIndividualData: {
                  address: {
                    locality: userCarInsurance.carCity,
                    zipCode: {
                      id: userCarInsurance.carPostCode,
                    },
                  },

                  birthDate: '', //'1985-10-30'
                  employmentDetails: {
                    vatCategory: {
                      mnemonic: 'CONF',
                    },
                  },
                  maritalStatus: {
                    mnemonic: '', //'S',
                  },
                  sexCode: {
                    mnemonic: '', //'M',
                  },
                },
                customerIdentification: {
                  identificationNumber: user.numeroDocumento, //20085691156,
                  identificationType: {
                    mnemonic: '12', //'00'
                  },
                },
                firstName1: user.nombre,
                identificationNumber: user.numeroDocumento, //20085691156,
                lastName1: user.apellido,
                personType: {
                  mnemonic: 'F',
                },
              },
              paymentMethod: {
                sPaymentMethodId:
                  userCarInsurance.carPreferencePay === 'debitoTarjetaCredito'
                    ? 'T'
                    : 'C', // T o C
              },
              productType: {
                sProductTypeId: 33,
              },
              systemUser: {
                userId: 'NTDOM\\MAG89965', //'ISOLVTASEG',
              },
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          dispatch(setCarInsurance({ requestNumber: data.idRequest }));
          setDataPlanAutos(data.insurancePlan);
          dispatch(fetchInsurancePlansSuccess(data.insurancePlan || []));
          setLoading(false);
        } catch (error) {
          dispatch(setErrorMessage(mapErrorMessage('systemError')));
          history.push(`/error`);
        }
      }
      fetchDataPlanAutos();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, []);

  const [insurancePlansAuto, setDataPlanAutos] = useState();

  const { token } = useSelector(({ auth }) => ({
    token: auth.token,
  }));

  const { insuranceSelected, insurancePlans, activity } = useSelector(
    ({ insurances, insurancePlans, activity }) => {
      return {
        insuranceSelected: insurances.selected,
        insurancePlans: insurancePlans.plans,
        activity: activity,
      };
    }
  );

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
    carBrand: carInsurance.userCarInsurance.carBrand,
    carModel: carInsurance.userCarInsurance.carModel,
    carYear: carInsurance.userCarInsurance.carYear,
    carVersion: carInsurance.userCarInsurance.carVersion,
    isNew: carInsurance.userCarInsurance.isNew,
    carGNC: carInsurance.userCarInsurance.carGNC,
    carPriceGNC: carInsurance.userCarInsurance.carPriceGNC,
    carCity: carInsurance.userCarInsurance.carCity,
    carPreferencePay: carInsurance.userCarInsurance.carPreferencePay,
  }));

  const { insuranceName, insuranceProductId } = insuranceSelected || {};

  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [open, setOpen] = useState(false);

  let selected;

  if (activity.activity) {
    selected = activity.activity.selected;
  }

  const [activeStep] = useWizardSteps(
    insuranceName === 'INTEGRAL DE COMERCIO' || insuranceName === 'AUTOMOTOR'
      ? 2
      : 1
  );

  const [condition] = useState();
  const [condition2] = useState();
  const [selected2] = useState();

  useEffect(() => {
    if (insuranceName === 'INTEGRAL DE COMERCIO') {
      dispatch(fetchInsurancePlans(insuranceProductId, selected));
    } else {
      dispatch(fetchInsurancePlans(insuranceProductId));
      dispatch(setTaxes({ condition, condition2 }));
      dispatch(setActivityName({ selected2 }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insuranceProductId]);

  const suggestion = (
    <span>
      <b>Elegí el plan</b> que mejor se adapte a vos
    </span>
  );
  const carouselEnabled =
    (insurancePlans && insurancePlans.length > 1) ||
    (insurancePlansAuto && insurancePlansAuto.length > 1);

  const handleClick = (plan, goTo) => {
    dispatch(setSelectedInsurancePlan(plan));
    if (
      insuranceSelected.insuranceName !== 'TECNO' &&
      insuranceSelected.insuranceName !== 'VIDA INDIVIDUAL' &&
      insuranceSelected.insuranceName !== 'INTEGRAL DE COMERCIO'
    ) {
      if (!goTo) goTo = nextSteps[insuranceName];
      return history.push(goTo);
    } else {
      setOpen(true);
    }
  };

  const handlePlanInfo = (plan, goTo) => {
    if (insuranceName === 'AUTOMOTOR') {
      dispatch(setSelectedInsurancePlan(plan));
      if (!goTo) goTo = nextSteps[insuranceName];
      return history.push(goTo);
    } else {
      dispatch(setSelectedInsurancePlan(plan));
      if (!goTo) goTo = nextSteps[insuranceName];
      return history.push(goTo);
    }
  };

  const renderModal = () => {
    if (insuranceSelected.insuranceName === 'TECNO') {
      return <ModelForm closeModal={closeModal} />;
    } else if (insuranceSelected.insuranceName === 'INTEGRAL DE COMERCIO') {
      return <CompanyInfo closeModal={closeModal} />;
    } else {
      return <LifeDeclaration closeModal={closeModal} />;
    }
  };

  const closeModal = (isOpen) => {
    setOpen(isOpen);
  };

  return (
    <>
      {open && <Modal closeModal={closeModal}>{renderModal()}</Modal>}
      <WizardLayout activeStep={activeStep} suggestion={suggestion} withBadge>
        {insurancePlans && insuranceName !== 'AUTOMOTOR' && (
          <Grid item xs={11} sm={12} container justify='center'>
            <>
              {mdUp || !carouselEnabled ? (
                <Box
                  display='flex'
                  justifyContent={
                    insurancePlans.length < 2 ? 'center' : 'space-around'
                  }
                  width={{ md: 900, lg: 1004 }}
                >
                  {insurancePlans.slice(0, 3).map((plan, key) => (
                    <PlanCard
                      key={key}
                      plan={plan}
                      handleClick={handleClick}
                      handlePlanInfo={handlePlanInfo}
                    />
                  ))}
                </Box>
              ) : (
                <Box
                  display='flex'
                  width={{ xs: '100%', sm: '80%', md: '100%' }}
                  justifyContent='center'
                >
                  <CardsCarousel
                    plans={insurancePlans}
                    maxWidth={600}
                    handleClick={handleClick}
                    handlePlanInfo={handlePlanInfo}
                  />
                </Box>
              )}
              <Box
                display='flex'
                justifyContent='center'
                flexWrap='wrap'
                className={classes.navigationContainer}
                width={{ md: 900, lg: 1004 }}
              >
                <WizardNavigation
                  showTerms
                  showGoToAll={insurancePlans.length > 3}
                  next={false}
                />
              </Box>
            </>
          </Grid>
        )}
        {insuranceName === 'AUTOMOTOR' && isLoading ? (
          <LoadingCars />
        ) : (
          insurancePlansAuto &&
          insuranceName === 'AUTOMOTOR' && (
            <Grid item xs={11} sm={12} container justify='center'>
              <>
                {mdUp || !carouselEnabled ? (
                  <Box
                    display='flex'
                    justifyContent={
                      insurancePlansAuto.length < 2 ? 'center' : 'space-around'
                    }
                    width={{ md: 900, lg: 1004 }}
                  >
                    {insurancePlansAuto.slice(0, 3).map((plan, key) => (
                      <PlanCardCar
                        key={key}
                        plan={plan}
                        handleClick={handleClick}
                        handlePlanInfo={handlePlanInfo}
                      />
                    ))}
                  </Box>
                ) : (
                  <Box
                    display='flex'
                    width={{ xs: '100%', sm: '80%', md: '100%' }}
                    justifyContent='center'
                  >
                    <CardsCarousel
                      plans={insurancePlansAuto}
                      maxWidth={600}
                      handleClick={handleClick}
                      handlePlanInfo={handlePlanInfo}
                    />
                  </Box>
                )}
                <Box
                  display='flex'
                  justifyContent='center'
                  flexWrap='wrap'
                  className={classes.navigationContainer}
                  width={{ md: 900, lg: 1004 }}
                >
                  <WizardNavigation
                    showTerms
                    showGoToAll={insurancePlansAuto.length > 3}
                    next={false}
                  />
                </Box>
              </>
            </Grid>
          )
        )}
      </WizardLayout>
    </>
  );
}
